import { BaseRequestQueryParam, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import {
  AddUserBankbookRequestBody,
  CoinMarketPriceResponseModel,
  CoinPairDto,
  CreateOrderRequestBody,
  CreateOrderResponseModel,
  CreateVinpayOrderResponseModel,
  MiniWalletResponseModel,
  TransferRequestBody,
  UpdateBalanceHistoryModel,
  UserBankbookResponseModel,
  VinpayOrderResponseModel,
  WalletResponseModel,
} from 'models/wallet';
import { getLocalStorage } from 'utils/sessionStorage';
import { DepositReponseModel } from 'models/deposit';

const walletApi = {
  getWallets: (): Promise<HttpResponse<WalletResponseModel[]>> => {
    const url = `/wallet/api/wallets`;
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getMiniWallets: (): Promise<HttpResponse<MiniWalletResponseModel>> => {
    const url = `/wallet/api/wallets/mini`;
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getCasinoWallets: (): Promise<HttpResponse<WalletResponseModel>> => {
    const url = '/wallet/api/casino/wallets';
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },

  createOrder: (
    request: CreateOrderRequestBody,
  ): Promise<HttpResponse<CreateOrderResponseModel>> => {
    const url = `/wallet/api/paypal/orders`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },

  transferBalance: (request: TransferRequestBody): Promise<HttpResponse<DepositReponseModel>> => {
    const url = '/wallet/api/wallets/transfer';
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },

  createVinpayOrder: (
    request: CreateOrderRequestBody,
  ): Promise<HttpResponse<CreateVinpayOrderResponseModel>> => {
    const url = `/wallet/api/vinpay/create-order`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },

  getVinpayOrder: (orderId: number): Promise<HttpResponse<VinpayOrderResponseModel>> => {
    const url = `/wallet/api/vinpay/order/${orderId}`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },

  getUserBankbooks: (): Promise<HttpResponse<UserBankbookResponseModel[]>> => {
    const url = `/wallet/api/bankbooks`;
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },

  addUserBankbooks: (
    request: AddUserBankbookRequestBody,
  ): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/bankbooks`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },

  deleteUserBankbooks: (id: number): Promise<HttpResponse<DepositReponseModel>> => {
    const url = `/wallet/api/bankbooks/${id}`;
    return handleRequest(
      axiosClient.delete(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },

  getTokenPrice: (symbol: string): Promise<HttpResponse<CoinMarketPriceResponseModel>> => {
    const url = `/wallet/api/common/coin-price/${symbol}`;
    return handleRequest(axiosClient.get(url));
  },

  getTokenPrices: (): Promise<HttpResponse<CoinMarketPriceResponseModel[]>> => {
    const url = `/wallet/api/common/coin-price`;
    return handleRequest(axiosClient.get(url));
  },

  getCoinPair: (): Promise<HttpResponse<CoinPairDto[]>> => {
    const url = `/wallet/api/common/coin-pairs`;
    return handleRequest(axiosClient.get(url));
  },

  getUpdateBalanceHistory: (
    params: BaseRequestQueryParam,
  ): Promise<HttpResponse<UpdateBalanceHistoryModel[]>> => {
    const url = '/wallet/api/update-balance-histories';
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default walletApi;
